import { PROFILE } from "../RootRouter.config";

export const PASSWORD = {
  relative: "password",
  url: () => PROFILE.url() + "/" + PASSWORD.relative,
  hashParam: "hash", // used in resetPwd.html
  loginLinkParam: "loginLink" // used in downloadAndLogin.html
};
export const SUBSCRIPTION = {
  relative: "subscription",
  url: () => PROFILE.url() + "/" + SUBSCRIPTION.relative
};
export const USEREDIT = {
  relative: "edit",
  url: () => PROFILE.url() + "/" + USEREDIT.relative
};
export const NOTIFICATIONS = {
  relative: "notifications",
  url: () => PROFILE.url() + "/" + NOTIFICATIONS.relative
};
export const AFFILIATE = {
  relative: "affiliate",
  url: () => PROFILE.url() + `/` + AFFILIATE.relative
};
export const TEACHERS = {
  relative: "teachers",
  url: () => PROFILE.url() + "/" + TEACHERS.relative
};
export const HELP_CENTER = {
  relative: "help",
  url: () => "/" + HELP_CENTER.relative
};
export const FEEDBACK = {
  relative: "feedback",
  url: () => "/" + FEEDBACK.relative
};
